<template>
    <default-sidebar :active="$store.state.sidebars.showPropertyCreateForm">
        <property-create-form v-if="$store.state.sidebars.showPropertyCreateForm"/>
    </default-sidebar>
</template>

<script>
    import DefaultSidebar from "./DefaultSidebar";
	import PropertyCreateForm from "@/components/forms/PropertyCreateForm.vue";

    export default {
        name: "DocumentsCreateFormSidebar",
        components: {
            DefaultSidebar,
	        PropertyCreateForm
        },
        data() {
            return {

            }
        },
    }
</script>

<style scoped lang="scss">

</style>